import type { ExerciseData, ExerciseViewProps } from '../exercises';
export { ExerciseData, ExerciseViewProps };
import { Question } from '../interfaces';
import { Module1S1ExerciseIntro } from './module1/Module1S1ExerciseIntro';
import { Module1S1Exercise1 } from './module1/Module1S1Exercise1';
import {
    dataKeys as dataKeys112,
    Module1S1Exercise2,
    questions as questions112,
} from './module1/Module1S1Exercise2';
import {
    dataKeys as dataKeys113,
    Module1S1Exercise3,
    questions as questions113,
} from './module1/Module1S1Exercise3';
import { Module1S2ExerciseIntro } from './module1/Module1S2ExerciseIntro';
import {
    dataKeys as dataKeys121,
    Module1S2Exercise1,
    questions as questions121,
} from './module1/Module1S2Exercise1';
import {
    dataKeys as dataKeys122,
    Module1S2Exercise2,
    questions as questions122,
} from './module1/Module1S2Exercise2';
import { ModuleIntroExercise } from './moduleIntro/ModuleIntroExercise';
import { Module2S1ExerciseIntro } from './module2/Module2S1ExerciseIntro';
import {
    dataKeys as dataKeys211,
    Module2S1Exercise1,
    questions as questions211,
} from './module2/Module2S1Exercise1';
import { Module2S1Exercise2 } from './module2/Module2S1Exercise2';
import { exerciseData213 } from './module2/Module2S1Exercise3';
import { Module2S1ExerciseCompleted } from './module2/Module2S1ExerciseCompleted';
import { exerciseData21goal } from './module2/Module2S1ExerciseGoal';
import { Module2S1Exercise4 } from './module2/Module2S1Exercise4';
import { Module2S2ExerciseIntro } from './module2/Module2S2ExerciseIntro';
import { exerciseData221 } from './module2/Module2S2Exercise1';
import { exerciseData222 } from './module2/Module2S2Exercise2';
import { exerciseData222Completed } from './module2/Module2S2Exercise2Completed';
import { exerciseData222Goal } from './module2/Module2S2ExerciseGoal';
import { exerciseData31Intro } from './module3/Module3S1ExerciseIntro';
import { exerciseData311 } from './module3/Module3S1Exercise1';
import { exerciseData312 } from './module3/Module3S1Exercise2';
import { exerciseData313 } from './module3/Module3S1Exercise3';
import { exerciseData314 } from './module3/Module3S1Exercise4';
import { exerciseData321 } from './module3/Module3S2Exercise1';

const noKeys: string[] = [];
const noQuestions: Question[] = [];

export function getExerciseData(code: string): ExerciseData {
    switch (code) {
        case '0.3':
            return {
                ExerciseView: ModuleIntroExercise,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '1.1.intro':
            return {
                ExerciseView: Module1S1ExerciseIntro,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '1.1.1':
            return {
                ExerciseView: Module1S1Exercise1,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '1.1.2':
            return {
                ExerciseView: Module1S1Exercise2,
                dataKeys: dataKeys112,
                questions: questions112,
            };
        case '1.1.3':
            return {
                ExerciseView: Module1S1Exercise3,
                dataKeys: dataKeys113,
                questions: questions113,
            };

        case '1.2.intro':
            return {
                ExerciseView: Module1S2ExerciseIntro,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '1.2.1':
            return {
                ExerciseView: Module1S2Exercise1,
                dataKeys: dataKeys121,
                questions: questions121,
            };
        case '1.2.2':
            return {
                ExerciseView: Module1S2Exercise2,
                dataKeys: dataKeys122,
                questions: questions122,
            };
        case '2.1.intro':
            return {
                ExerciseView: Module2S1ExerciseIntro,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '2.1.1':
            return {
                ExerciseView: Module2S1Exercise1,
                dataKeys: dataKeys211,
                questions: questions211,
            };
        case '2.1.2':
            return {
                ExerciseView: Module2S1Exercise2,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '2.1.3':
            return exerciseData213;
        case '2.1.4':
            return {
                ExerciseView: Module2S1Exercise4,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '2.1.completed':
            return {
                ExerciseView: Module2S1ExerciseCompleted,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '2.1.goal':
            return exerciseData21goal;
        case '2.2.intro':
            return {
                ExerciseView: Module2S2ExerciseIntro,
                dataKeys: noKeys,
                questions: noQuestions,
            };
        case '2.2.1':
            return exerciseData221;
        case '2.2.2':
            return exerciseData222;
        case '2.2.2.completed':
            return exerciseData222Completed;
        case '2.2.2.goal':
            return exerciseData222Goal;
        case '3.1.intro':
            return exerciseData31Intro;
        case '3.1.1':
            return exerciseData311;
        case '3.1.2':
            return exerciseData312;
        case '3.1.3':
            return exerciseData313;
        case '3.1.4':
            return exerciseData314;
        case '3.2.1':
            return exerciseData321;
    }
}
